import Swiper from "../../../vendors/swiper.min";
export const topBannerSlider = {
	init: function () {
		const topBannerSliderList = document.querySelector(".top-banner__slider");
		if (topBannerSliderList) {
			const topBannerSliderSlides =
				topBannerSliderList.querySelectorAll(".top-banner__slide");
			if (topBannerSliderSlides.length > 1) {
				this.initSwiper();
			}
		}
	},
	initSwiper: function () {
		// const bannerSwiper = document.querySelectorAll(".swiper-wrapper");
		const topBannerSliderList = document.querySelector(".top-banner__slider");
		// const that = this;
		var mySwiper = new Swiper(".top-banner__slider", {
			// Optional parameters
			// observer: true,
			// init: false,
			spaceBetween: 15,
			speed: 2000,
			centeredSlides: true,
			loop: true,
			slidesPerView: 1,
			slidesPerGroup: 1,
			autoplay: {
				delay: 5000,
			},
			keyboard: {
				enabled: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: 'Poprzedni slajd',
				nextSlideMessage: 'Następny slajd',
				firstSlideMessage: 'To pierwszy slajd',
				lastSlideMessage: 'To ostatni slajd',
				paginationBulletMessage: 'Przejdź do slajdu {{index}}',
			},

			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
		if (topBannerSliderList.length) {
			mySwiper.init();
		}
		// mySwiper.el.addEventListener('mouseenter', () => {
		// 	mySwiper.autoplay.stop();
		// 	// console.log("zatrzymaj swiper")
		// });
		// mySwiper.el.addEventListener('mouseleave', () => mySwiper.autoplay.start());

		// mySwiper.el.addEventListener('focusin', () => mySwiper.autoplay.stop());
		// mySwiper.el.addEventListener('focusout', () => mySwiper.autoplay.start());
		const toggleBtn = document.querySelector('.top-banner__slider-toggle button');
		toggleBtn.addEventListener('click', () => {
			// console.log("pauza klik")
			const isPlaying = mySwiper.autoplay.running;
			if (isPlaying) {
				mySwiper.autoplay.stop();
				toggleBtn.setAttribute('aria-pressed', 'true');
				// zmień ikonę na „start”
				toggleBtn.classList.remove("slider-pause");
				toggleBtn.classList.add("slider-start");
			} else {
				mySwiper.autoplay.start();
				toggleBtn.setAttribute('aria-pressed', 'false');
				// zmień ikonę na „pauza”
				toggleBtn.classList.remove("slider-start");
				toggleBtn.classList.add("slider-pause");
		}
		});
	},
	slickInital: function (topBannerSliderList, topBannerSliderSlides) {
		const prevArrowEl =
			'<button type="button" class="button-b2c bg--blue button-b2c--circle button-b2c--with-arrow check-availability-2__btn check-availability-2__btn--arrow right-slider-arrow"><span class="sr-only">' +
			topBannerSliderList.getAttribute("data-text-prev") +
			"</span></button>";
		const nextArrowEl =
			'<button type="button" class="button-b2c bg--blue button-b2c--circle button-b2c--with-arrow check-availability-2__btn check-availability-2__btn--arrow left-slider-arrow"><span class="sr-only">' +
			topBannerSliderList.getAttribute("data-text-next") +
			"</span></button>";
		$(topBannerSliderList).slick({
			centerMode: true,
			accessibility: true,
			prevArrow: prevArrowEl,
			nextArrow: nextArrowEl,
			centerPadding: "none",
		});
	},
};
